/**
 * 部署模式配置
 * 当使用 build-local 构建时，VITE_DEPLOY_MODE=local 会被注入
 * 本地化部署模式下会隐藏：订阅升级、用户反馈、隐私政策、服务条款、订阅管理
 */
export const isLocalDeployment =
  (import.meta as { env?: { VITE_DEPLOY_MODE?: string } }).env?.VITE_DEPLOY_MODE === 'local';

/**
 * Google OAuth 配置
 * 这些配置由后端提供，前端仅使用后端返回的授权 URL
 */
export const googleConfig = {
  // Google 回调路径
  callbackPath: '/google/auth',
  // 是否启用 Google 登录
  enabled: true,
};
